import httpClient from "../http/http-client";
import { IAuthMethodResponse, IOrganisationSso, IOrganisationSsoUpdate } from './sso.model';

export default class SsoService {
  http;

  constructor() {
    this.http = httpClient
  }

  // Email-first: ask the backend whether this email signs in with a password or
  // via SSO (and where to start the SSO flow).
  async getAuthMethod(email: string, returnTo?: string): Promise<IAuthMethodResponse> {
    return this.http.post('auth/method', { email, returnTo })
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; })
  }

  // Admin: the org's SSO configuration.
  async getOrganisationSso(): Promise<IOrganisationSso> {
    return this.http.get('user/sso')
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; })
  }

  async updateOrganisationSso(payload: IOrganisationSsoUpdate): Promise<IOrganisationSso> {
    return this.http.put('user/sso', payload)
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; })
  }
}
